import classNames from "classnames";
import { NavigationModel } from "models/NavigationModel";
import { useLayout } from "providers";

interface HeaderNavItemProps {
  className?: string;
  item: NavigationModel;
}

export const HeaderDropdownItem: React.FC<HeaderNavItemProps> = ({ className = "dropdown-item", item }) => {
  const { handleNavClick, isExternal } = useLayout();
  let { isSelected, tooltip, iconStart, iconEnd, text } = item;

  className = classNames(className, isSelected ? "active" : "");

  return (
    <button
      className={classNames(className, "d-flex")}
      onClick={(e) => {
        e.preventDefault();
        handleNavClick(item);
      }}
    >
      {iconStart ? <div className="sbb-header-nav-item-icon me-2">{iconStart}</div> : null}
      {tooltip && (
        <span className="global-tooltip-trigger" title={tooltip}>
          {text}
        </span>
      )}

      {!tooltip && <span>{text}</span>}

      {iconEnd ? <div className="sbb-header-nav-item-icon ms-2">{iconEnd}</div> : null}

      {isExternal(item) && (
        <span className="sbb-header-nav-item-icon ms-2 position-absolute end-0 mr-2">
          <i className="ms-Icon ms-Icon--NavigateExternalInline" />
        </span>
      )}
    </button>
  );
};
